(function () {
  'use strict';

  function fmtPrice(str) {
    var n = parseFloat(str);
    return isNaN(n) ? '' : '€' + n.toFixed(2).replace('.', ',');
  }

  function shuffle(arr) {
    var a = arr.slice();
    for (var i = a.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = a[i]; a[i] = a[j]; a[j] = tmp;
    }
    return a;
  }

  function getCurrentProductId() {
    if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
      return window.ShopifyAnalytics.meta.product.id;
    }
    var scripts = Array.from(document.scripts);
    for (var i = 0; i < scripts.length; i++) {
      var text = scripts[i].textContent;
      if (text.indexOf('"variants"') > -1 && text.indexOf('"id"') > -1) {
        var m = text.match(/"id"\s*:\s*(\d{10,})/);
        if (m) return parseInt(m[1]);
      }
    }
    return null;
  }

  function updateBundleTotal(bundleEl) {
    var totalEl = bundleEl.querySelector('.bundle-total');
    if (!totalEl) return;
    var total = 0;
    bundleEl.querySelectorAll('.bundle-item').forEach(function(item) {
      var cb = item.querySelector('input[type=checkbox]');
      if (!cb || !cb.checked) return;
      var priceEl = item.querySelector('.bundle-price');
      if (!priceEl) return;
      var price = parseFloat(priceEl.textContent.replace('€', '').replace(',', '.').trim());
      if (!isNaN(price)) total += price;
    });
    totalEl.textContent = 'Total del look: €' + total.toFixed(2).replace('.', ',');
  }

  async function init() {
    var related = document.getElementById('related');
    var bundle = document.getElementById('bundle');
    if (!related && !bundle) return;

    var currentId = getCurrentProductId();
    var allProducts = [];
    try {
      var resp = await fetch('/collections/all/products.json?limit=50');
      var data = await resp.json();
      allProducts = data.products || [];
    } catch (e) { return; }

    var others = allProducts.filter(function(p) { return p.id !== currentId; });

    /* ── Related section ── */
    if (related) {
      var grid = related.querySelector('.related-grid');
      if (grid) {
        var relItems = shuffle(others).slice(0, 4);
        grid.innerHTML = relItems.map(function(p) {
          var img = (p.images && p.images[0]) ? p.images[0].src : '';
          var price = fmtPrice(p.variants && p.variants[0] ? p.variants[0].price : '0');
          var href = '/products/' + p.handle;
          var alt = p.title.replace(/"/g, '&quot;');
          return '<a class="rc-card" href="' + href + '">'
            + '<div class="rc-img">'
            + (img ? '<img src="' + img + '" alt="' + alt + '" loading="lazy">' : '')
            + '<div class="rc-quick-add">Ver producto →</div>'
            + '</div>'
            + '<p class="rc-name">' + p.title + '</p>'
            + '<p class="rc-price">' + price + '</p>'
            + '</a>';
        }).join('');
      }
    }

    /* ── Bundle section ── */
    if (bundle) {
      var addItems = Array.from(bundle.querySelectorAll('.bundle-item.bundle-add'));
      var bundleProds = shuffle(others).slice(0, addItems.length);

      addItems.forEach(function(item, i) {
        var product = bundleProds[i];
        if (!product) return;
        var img = (product.images && product.images[0]) ? product.images[0].src : '';
        var price = fmtPrice(product.variants && product.variants[0] ? product.variants[0].price : '0');
        var variantId = product.variants && product.variants[0] ? product.variants[0].id : null;

        var imgEl = item.querySelector('.bundle-img img');
        if (imgEl) { imgEl.src = img; imgEl.alt = product.title; }

        var nameEl = item.querySelector('.bundle-name');
        if (nameEl) nameEl.textContent = product.title;

        var priceEl = item.querySelector('.bundle-price');
        if (priceEl) priceEl.textContent = price;

        if (variantId) {
          item.dataset.variantId = variantId;
          var cb = item.querySelector('input[type=checkbox]');
          if (cb) cb.dataset.variantId = variantId;
        }
      });

      updateBundleTotal(bundle);
      bundle.addEventListener('change', function() { updateBundleTotal(bundle); });

      /* Override bundle add-to-cart button */
      var oldBtn = bundle.querySelector('.btn-bundle');
      if (oldBtn) {
        var newBtn = oldBtn.cloneNode(true);
        oldBtn.parentNode.replaceChild(newBtn, oldBtn);
        newBtn.addEventListener('click', async function(e) {
          e.preventDefault();
          e.stopPropagation();
          var items = [];

          var firstItem = bundle.querySelector('.bundle-item:not(.bundle-add)');
          var firstCb = firstItem && firstItem.querySelector('input[type=checkbox]');
          if (firstCb && firstCb.checked) {
            var mainInput = document.querySelector('select[name="id"], input[name="id"]');
            var mainVid = mainInput ? parseInt(mainInput.value) : null;
            if (mainVid) items.push({ id: mainVid, quantity: 1 });
          }

          bundle.querySelectorAll('.bundle-item.bundle-add').forEach(function(item) {
            var cb = item.querySelector('input[type=checkbox]');
            if (cb && cb.checked && item.dataset.variantId) {
              items.push({ id: parseInt(item.dataset.variantId), quantity: 1 });
            }
          });

          if (!items.length) return;
          newBtn.disabled = true;
          var orig = newBtn.textContent;
          newBtn.textContent = 'Añadiendo...';
          try {
            var r = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: items })
            });
            if (r.ok) {
              newBtn.textContent = '✓ Añadido al carrito';
              document.dispatchEvent(new CustomEvent('cart:refresh'));
              document.dispatchEvent(new CustomEvent('cart:open'));
              setTimeout(function() { newBtn.disabled = false; newBtn.textContent = orig; }, 2500);
            } else { throw new Error('fail'); }
          } catch (err) { newBtn.disabled = false; newBtn.textContent = orig; }
        });
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();